import lrTag from './_src/lrTag.vue'

lrTag.install = function(Vue) {
  Vue.component(lrTag.name, lrTag)
}

export default lrTag